export interface LoginRequest {
  username: string;
  password: string;
  mfaCookieExists: boolean;
}



/**
 * Authenticated user profile.
 */
export interface AuthUser {
  webPersonId: number;
  username: string;
  statEmployeeId: number;
  userFirstName: string;
  userLastName: string;
  userFullName: string;
  userOrganizationId: number;
  canSchedule: number;
  timeZone: string;
  passwordExpireInDays: number;
  defaultReportGroupId: number;
  mfaStatus: "valid" | "invalid";
}

/**
 * Authentication state.
 */
export enum AuthStatus {
  signed_out,
  signed_in,
  mfa_pending,
}

/**
 * Unified auth state object.
 */
export interface AuthState {
  user: AuthUser | null;
  authStatus: AuthStatus;
  mfaData?: MfaData | null;
}



/**
 * User login credentials.
 */



/**
 * Login response from backend (includes user and MFA info).
 */
export interface LoginResponse {
  authUser: AuthUser;
  mfaInfo: MfaData;
}

/**
 * MFA contact information and settings.
 */
export interface MfaData {
  phone: string;
  email: string;
}
